import React from "react";
import { GrAdd, GrSubtract } from "react-icons/gr";
import { styled } from "@glitz/react";
import { fontSize, mediumGrey, black } from "../../theme";

type SlimQuantitySelectorProps = {
  initialQuantity: number;
  onAdd: () => void;
  onSubtract: () => void;
};

const SlimQuantitySelector: React.FC<SlimQuantitySelectorProps> = ({
  initialQuantity,
  onAdd,
  onSubtract,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "30px",
      }}
    >
      <SubtractButton onClick={() => onSubtract()}>
        <GrSubtract />
      </SubtractButton>
      <QtyInput>{initialQuantity}</QtyInput>
      <AddButton onClick={() => onAdd()}>
        <GrAdd />
      </AddButton>
    </div>
  );
};
const QtyInput = styled.div({
  width: "40px",
  height: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: fontSize.m,

  border: {
    top: { style: "solid", width: "1px", color: black },
    bottom: { style: "solid", width: "1px", color: black },
    left: { style: "none" },
    right: { style: "none" },
  },
});

const QtyButton = styled.button({
  fontSize: fontSize.m,
  cursor: "pointer",
  backgroundColor: mediumGrey,
  border: { xy: { color: black, width: "1px", style: "solid" } },
  height: "100%",
  display: "flex",
  alignItems: "center",
});

const SubtractButton = styled(QtyButton, {
  borderTopLeftRadius: "4px",
  borderBottomLeftRadius: "4px",
});

const AddButton = styled(QtyButton, {
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
});

export default SlimQuantitySelector;
